<template lang="html">
  <sc-container>
    <sc-flex :is-between="true">
      <sc-h1>Help Center</sc-h1>
    </sc-flex>
    <sc-card>
      <sc-flex :is-column="true" :gap="32">
        <sc-flex
          v-for="(category, categoryKey) in clientGuides"
          :key="categoryKey"
          :is-column="true"
          :gap="8"
        >
          <sc-h6 :is-secondary="true">{{ category.title }}</sc-h6>
          <sc-flex class="guide-container" :gap="1" :is-column="true">
            <div
              class="guide"
              v-for="(item, key) in category.sections"
              :key="key"
            >
              <input
                type="checkbox"
                :name="item.id"
                :id="item.id"
                :checked="false"
              />
              <label :for="item.id" class="guide__label">
                <sc-h5>{{ item.title }}</sc-h5>
              </label>
              <div class="guide__content">
                <div v-html="item.description"></div>
                <v-img
                  class="image"
                  v-if="item.image"
                  :src="item.image"
                  :alt="`Thumbnail of {{ item.title }}`"
                />
              </div>
            </div>
          </sc-flex>
        </sc-flex>
        <sc-hr :is-light="true"></sc-hr>
        <sc-flex :is-column="true" :gap="16">
          <sc-h3>Support</sc-h3>
          <sc-small
            >For further inquiries beyond these frequently asked questions,
            please don&apos;t hesitate to contact us.</sc-small
          >
          <sc-hr v-if="showContactForm"></sc-hr>
          <contact-form v-if="showContactForm" />
          <sc-button-group v-else>
            <sc-button type="secondary" @click="showContactForm = true">
              Contact Us
            </sc-button>
          </sc-button-group>
        </sc-flex>
      </sc-flex>
    </sc-card>
  </sc-container>
</template>

<script>
import { mapGetters } from 'vuex';
import ContactForm from '../components/ContactForm.vue';

export default {
  name: 'ClientHelpCenter',
  components: {
    ContactForm,
  },
  computed: {
    ...mapGetters({
      currentFirm: 'currentFirm',
      isEmailRefDisabled: 'isEmailRefDisabled',
    }),
  },
  data() {
    return {
      showContactForm: false,
      clientGuides: [
        {
          id: 'sign-in-issues',
          title: 'Sign-in Issues',
          sections: [
            {
              id: 'resend-sign-in-link',
              title: 'Resend sign-in link',
              description:
                'Please enter your email address and select <b>Sign-in Using A Different Way</b>. An email containing a sign-in link will be sent to your inbox.',
            },
            {
              id: 'forgot-password',
              title: 'Forgot Password',
              description:
                'Please enter your email address and select <b>Forgot Password?</b>. An email containing a password reset link will be sent to your inbox.',
            },
            {
              id: 'change-the-email-address-of-an-entity',
              title: 'Change the email address of an entity',
              description:
                'Please contact us using the <b>Contact Us</b> form below.',
            },
          ],
        },
        {
          id: 'mobile-related',
          title: 'Mobile Related',
          sections: [
            {
              id: '3',
              title: 'Upload Documents from Mobile',
              description:
                'Open the Documents tab on your mobile device. Then tap the <b>+</b> icon located in the top right corner of the Documents page.',
              image: require('../assets/help/take-picture1.png'),
            },
            {
              id: '4',
              title: 'Selecting Files',
              description:
                'Click <b>Select Files</b>, and select <b>Take Photo or Video</b>. You can also upload a previously taken picture or saved document with <b>Photo Library</b> or <b>Choose Files<b/>',
              image: require('../assets/help/take-picture2.png'),
            },
            {
              id: '5',
              title: 'Uploading Files',
              description:
                'Once the correct file is selected, click the <b>Upload All</b> button.',
              image: require('../assets/help/take-picture3.png'),
            },
          ],
        },
        {
          id: 'questionnaires',
          title: 'Questionnaires',
          sections: [
            {
              id: '6',
              title: 'Selecting preferred contact method',
              description:
                "If this is your first time completing a questionnaire, you'll be prompted to select a preferred method of contact.",
              image: require('../assets/help/answer-questionnaire1.png'),
            },
            {
              id: '7',
              title: 'Signing Engagement Letter',
              description:
                'If the questionnaire has an engagement letter attached, type in your full name and click <b>I Agree</b> to sign it.',
              image: require('../assets/help/answer-questionnaire2.png'),
            },
            {
              id: '9',
              title: 'Filling the Questionnaire',
              description:
                'For the actual questions, select or fill in the applicable answer or select <b>Not Applicable</b>.',
              image: require('../assets/help/answer-questionnaire4.png'),
            },
          ],
        },
      ],
      selectedGuide: null,
    };
  },
};
</script>

<style scoped="true" lang="css">
.guide-container {
  overflow: hidden;

  text-align: left !important;
}

.guide input {
  position: absolute;
  z-index: -1;

  opacity: 0;
}

.guide .image {
  flex-grow: 1;
  width: 360px;
  max-width: 360px;

  border-radius: 8px;
}

.guide__content {
  position: relative;

  height: 0;
  opacity: 0;
  display: flex;
  gap: 16px;
  justify-content: space-between;
  padding: 0 12px;
  overflow: hidden;

  font-size: 14px;
  line-height: 22px;
  transition: all 160ms ease-in-out;

  user-select: none;
}

.guide input:checked ~ .guide__content {
  height: auto;
  opacity: 1;
  padding: 12px 12px;
}

.guide__label {
  position: relative;
  z-index: 1;

  display: flex;
  justify-content: space-between;
  padding: 8px;

  background-color: var(--gray-50);
  color: var(--gray-900) !important;
  cursor: pointer;
}

.guide__label::after {
  display: block;
  height: 24px;
  width: 24px;

  transform: rotate(90deg);
  transition: all 160ms ease-in-out;

  content: '\276F';
  line-height: 24px;
  text-align: center;
}

.guide input:checked + .guide__label::after {
  transform: rotate(270deg);
}

@media (max-width: 640px) {
  .guide__content {
    flex-direction: column;
  }
}
</style>
